import { render } from "./NewsSection.vue?vue&type=template&id=d53a6060&scoped=true&ts=true"
import script from "./NewsSection.vue?vue&type=script&lang=ts"
export * from "./NewsSection.vue?vue&type=script&lang=ts"

import "./NewsSection.vue?vue&type=style&index=0&id=d53a6060&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d53a6060"]])

export default __exports__